import { SafeUrl } from '@angular/platform-browser';

export enum GraphApiBodyContentType {
  Text = 'Text',
  HTML = 'HTML',
}

export enum MimeType {
  PLAIN_TEXT = 'text/plain',
  HTML = 'text/html',
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  JSON = 'application/json',
}

export enum GraphApiImportance {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
}

export interface GraphApiAttachment {
  '@odata.type': '#microsoft.graph.fileAttachment';
  name: string;
  contentType: MimeType;
  contentBytes: string;
  contentId?: string;
}

export interface GraphApiMailBody {
  message: {
    subject: string;
    body: {
      contentType: GraphApiBodyContentType;
      content: string;
    };
    importance: GraphApiImportance;
    toRecipients: {
      emailAddress: {
        address: string;
      };
    }[];
    ccRecipients?: {
      emailAddress: {
        address: string;
      };
    }[];
    attachments?: GraphApiAttachment[];
  };
}

export enum GraphResponseStatus {
  LOADING = 'Loading',
  ERROR = 'Error',
  COMPLETE = 'Complete',
}

export interface GraphResponse<T> {
  status: GraphResponseStatus;
  value: T;
}

export const MESSAGE_GRAPH_API_STATUS = {
  [GraphResponseStatus.ERROR]: 'Error in call, please search again.',
  [GraphResponseStatus.LOADING]: 'Loading...',
};

export interface GraphApiContactResponse {
  '@odata.context'?: any;
  value: GraphApiContact[];
}

export interface GraphApiContact {
  id: string;
  displayName?: string;
  userPrincipalName?: string;
  visibility?: string;
  mail?: string;
}

export interface GraphApiChatResponse {
  '@odata.context'?: string;
  '@odata.count'?: number;
  '@odata.nextLink'?: string;
  value: GraphApiChat[];
}

export interface GraphApiChat {
  id: string;
  displayName: string;
  topic: string;
  photo: SafeUrl | string;
  chatType: string;
  members: GraphApiChatMember[];
}

export interface GraphApiChatMember {
  userId: string;
  displayName: string;
}

export interface GraphApiTeamResponse {
  '@odata.context': string;
  '@odata.count': number;
  value: GraphApiTeam[];
}

export interface GraphApiTeam {
  id: string;
  displayName: string;
}

export interface GraphApiTeamChannelResponse {
  '@odata.context': string;
  '@odata.count': number;
  value: GraphApiTeamChannel[];
}

export interface GraphApiTeamChannel {
  id: string;
  displayName: string;
}

export interface GraphApiMessageRequest {
  body: string;
  base64Image?: string;
}
